export const isInRange = (n, el) => {
    if (el && typeof el.start == 'number' && el.end) {
        let start = Math.min(el.start, el.end);
        let end = Math.max(el.start, el.end);
        if (start <= n && end >= n) {
            return true;
        }
    }
};
export const cutIntersects = (cuts, cutPoint) => {
    let found = null;
    if (cuts.length) {
        cuts.forEach((el, idx) => {
            if (isInRange(cutPoint, el)) {
                found = idx;
            }
        });
    }
    return found;
};
